import { render } from "./TeamPointsDetails.vue?vue&type=template&id=7a37bb48&scoped=true"
import script from "./TeamPointsDetails.vue?vue&type=script&lang=js"
export * from "./TeamPointsDetails.vue?vue&type=script&lang=js"

import "./TeamPointsDetails.vue?vue&type=style&index=0&id=7a37bb48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a37bb48"]])

export default __exports__